export default "/images/youtube-icon.svg?f277a219069be0a58c3ee77a6e84769e";